// Minimal YouTube embed. YouTube's own chrome already provides the play button
// and the seek bar, so we keep those and switch off the rest: no related videos
// from other channels (rel=0), no info cards (iv_load_policy=3), reduced
// branding. Using the native controls means no IFrame Player API and no
// enablejsapi/origin handshake, which is one less thing that can fail.

interface VideoPlayerProps {
	videoId: string;
	title: string;
}

const PARAMS = new URLSearchParams({
	modestbranding: '1',
	rel: '0',
	iv_load_policy: '3',
	playsinline: '1',
	color: 'white',
});

export default function VideoPlayer({ videoId, title }: VideoPlayerProps) {
	return (
		<div className="home-video__frame">
			<iframe
				src={`https://www.youtube-nocookie.com/embed/${videoId}?${PARAMS}`}
				title={title}
				loading="lazy"
				allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>
		</div>
	);
}
